/*
 * $Id:: index.js 2020/11/12 10:02 otsolka
 *
 *        . * .
 *      * RRRR  *   Copyright (c) 2012-2021 EUIPO: European Intelectual
 *     .  RR  R  .  Property Organization (trademarks and designs).
 *     *  RRR    *
 *      . RR RR .   ALL RIGHTS RESERVED
 *       *. _ .*
 *
 *  The use and distribution of this software is under the restrictions exposed in 'license.txt'
 */

import React, { useState, useEffect } from 'react';

import Button from '@material-ui/core/Button';
import { useSelector } from 'react-redux';

import { me as meSlice } from '../../pages/AuthenticatedPage/authenticationSlice';
import { getLocale } from '../../providers';
import { t } from '../../providers/TranslationProvider';

const ExternalLinks = ({ links, className = '', icon }) => {
    const me = useSelector(meSlice);
    const [language, setLanguage] = useState('');

    useEffect(() => {
        const locale = getLocale();
        setLanguage(locale.charAt(0).toUpperCase() + locale.slice(1));
    }, [me]);

    return (
        <React.Fragment>
            {links &&
                links.length > 0 &&
                links.map((linkItem, index) =>
                    icon ? (
                        <Button
                            aria-label={t(linkItem['text'])}
                            key={index}
                            className={className}
                            startIcon={icon}
                            onClick={() => window.open(linkItem[`link${language}`])}>
                            {t(linkItem['text'])}
                        </Button>
                    ) : (
                        <a
                            key={index}
                            href={linkItem[`link${language}`]}
                            target={'_blank'}
                            rel="noopener noreferrer"
                            className={className}
                            title={t('open.new.tab')}>
                            {t(linkItem['text'])}
                        </a>
                    )
                )}
        </React.Fragment>
    );
};

export default ExternalLinks;
